import styled                      from 'styled-components';

import { CloseVector             } from 'src/components/vector/close';

import { IconButtonVariants      } from 'src/components/common/icon-button';
import { ButtonVariants          } from 'src/components/common/button';
import { TypographyVariants      } from 'src/components/common/typography';
import { LabeledVariants         } from 'src/components/common/labeled';
import { InputTextboxVariants    } from 'src/components/common/input/input-textbox';
import { TwoActionDialogVariants } from 'src/components/common/two-action-dialog';

import { AttachmentDOCVariants   } from 'src/components/features/inspection/edit/attachment-doc';
import { StaticValueVariants     } from 'src/components/features/inspection/view/static-value';

import { themeColors,
         cssFlexRow,
         cssFlexColumn           } from 'src/providers/theme/shared';



export type ComplaintFragmentLookAndFeel = {
  containerBackgroundColor: string;
  containerPaddings: number[];

  headerHeight: number;
  headerIconButtonVariant: IconButtonVariants;
  headerTypographyVariant: TypographyVariants;

  formPaddings: number[];
  formGap: number;
  formActionsGap: number;
  formSubmitToPadding: number;

  photoListGap: number;

  hrColor: string;

  labeledVariant: LabeledVariants;
  textboxVariant: InputTextboxVariants;
  submitButtonVariant: ButtonVariants;
  cancelButtonVariant: ButtonVariants;
  requestSendDialog: TwoActionDialogVariants;
  staticValueVariant: StaticValueVariants;
  attachmentDOCVariants: AttachmentDOCVariants;
}

const complaintfragment_light: ComplaintFragmentLookAndFeel = {
  containerBackgroundColor: themeColors.BackgroundFillLight,
  containerPaddings: [0, 16],

  headerHeight: 60,
  headerIconButtonVariant: 's46bluered',
  headerTypographyVariant: 'blackw400s20lh24',

  formPaddings: [20, 16],
  formGap: 30,
  formActionsGap: 16,
  formSubmitToPadding: 16,

  photoListGap: 10,

  hrColor: themeColors.SecondaryGray3,

  labeledVariant: 'light',
  textboxVariant: 'h48light',
  submitButtonVariant: 'h48bluefill',
  cancelButtonVariant: 'h48blueoutline',
  requestSendDialog: 'light',
  staticValueVariant: 'light',
  attachmentDOCVariants: 'light',
}

export type ComplaintFragmentVariants = 'light';

export const complaintfragment_variants: Map<ComplaintFragmentVariants, ComplaintFragmentLookAndFeel> = 
  new Map<ComplaintFragmentVariants, ComplaintFragmentLookAndFeel>([
    ['light', complaintfragment_light],
  ]);

export const Container = styled.div<{
  lookAndFeel: ComplaintFragmentLookAndFeel,
}>`
 ${cssFlexColumn};
  width: 100%;
  flex-grow: 2;
  padding-bottom: ${(args) => args.lookAndFeel.containerPaddings[1]}px;

  background-color: ${(args) => args.lookAndFeel.containerBackgroundColor};
`

export const HeaderContainer = styled.div<{
  lookAndFeel: ComplaintFragmentLookAndFeel,
}>`
  ${cssFlexRow};
  flex-shrink: 0;
  width: 100%;
  height: ${(args) => args.lookAndFeel.headerHeight}px;
  align-items: center;
  padding-left: ${(args) => args.lookAndFeel.containerPaddings[1]}px;
`

export const FormContainer = styled.div<{
  lookAndFeel: ComplaintFragmentLookAndFeel,
}>`
  ${cssFlexColumn};
  width: 100%;
  gap: ${(args) => args.lookAndFeel.formGap}px;

  overflow-y: auto;
`

export const SubmitContainer = styled.div<{
  lookAndFeel: ComplaintFragmentLookAndFeel,
}>`
  ${cssFlexRow};
  gap: ${(args) => args.lookAndFeel.formActionsGap}px;
  flex-shrink: 0;
  padding-top: ${(args) => args.lookAndFeel.formSubmitToPadding}px;

  & > *:first-child {
    width: 60%;
  }
`

export const PhotoList = styled.div<{
  lookAndFeel: ComplaintFragmentLookAndFeel,
}>`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: 1fr;
  grid-column-gap: ${(args) => args.lookAndFeel.photoListGap}px;
  grid-row-gap: ${(args) => args.lookAndFeel.photoListGap}px;
`

export const Hr = styled.div<{
  lookAndFeel: ComplaintFragmentLookAndFeel,
}>`
  border-top: 1px solid ${(args) => args.lookAndFeel.hrColor};
`

export const CloseOutlineVectorBig = styled(CloseVector)`
  width: 16px;
  height: 16px;
`;